import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Edit2, Trash2, GripVertical } from 'lucide-react';

const SortableOption = ({ option, onEdit, onDelete, onToggleActive }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: option.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg px-3 py-2 border border-purple-200 hover:border-purple-400 transition-all flex items-center gap-2"
    >
      <div {...attributes} {...listeners} className="cursor-grab active:cursor-grabbing text-gray-400 hover:text-purple-600">
        <GripVertical size={16} />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-gray-800 text-sm">{option.label}</span>
          <span className="text-xs text-gray-500">
            {option.value_int !== null && option.value_int !== undefined ? `(${option.value_int})` : `"${option.value_str}"`}
          </span>
          <span className={`px-1.5 py-0.5 text-xs font-semibold rounded ${
            option.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
          }`}>
            {option.is_active ? '✓' : '✗'}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-1">
        <button
          onClick={onToggleActive}
          className="p-1 hover:bg-purple-100 rounded transition-colors text-xs"
        >
          {option.is_active ? '👁️' : '👁️‍🗨️'}
        </button>
        <button onClick={onEdit} className="p-1 hover:bg-purple-100 text-purple-600 rounded transition-colors">
          <Edit2 size={12} />
        </button>
        <button onClick={onDelete} className="p-1 hover:bg-red-100 text-red-600 rounded transition-colors">
          <Trash2 size={12} />
        </button>
      </div>
    </div>
  );
};

export default SortableOption;